import { ActionResult, BaseAction } from "./BaseAction";
import { ChainedAction } from "./ChainedAction";
import { ConfirmAction } from "./ConfirmAction";
import { FunctionAction } from "./FunctionAction";
import { VoidAction } from "./VoidAction";
export class FormAction extends ChainedAction {
    form;
    constructor(form, options = {}) {
        options = {
            ...options,
        };
        const validationAction = new FunctionAction(async () => {
            const isValid = await form.trigger();
            if (!isValid) {
                // Submit the form anyway to get desired revalidation behaviour
                await form.submit();
            }
            return isValid ? ActionResult.success : ActionResult.aborted;
        }, {
            successFeedback: "never",
        });
        const submitAction = new FunctionAction(async (...args) => {
            const result = await form.submit(...args);
            if (result === false) {
                return ActionResult.aborted;
            }
        }, {
            successFeedback: options.successFeedback,
        });
        super([
            validationAction,
            form.confirmation
                ? new ConfirmAction(submitAction, form.confirmation)
                : submitAction,
        ], options);
        this.form = form;
        // Constructor hooks
        this.useOnChange("isBusy", (isBusy) => {
            this.form.disableForm(isBusy);
        }, [this.form]);
    }
    static useDryAction() {
        const action = new ChainedAction([new VoidAction(), new VoidAction()]);
        // "Dry version" of Constructor hooks
        BaseAction.useOnChangeDry([null]);
        return action;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybUFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvYWN0aW9ucy9Gb3JtQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBaUIsWUFBWSxFQUFFLFVBQVUsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUN2RSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFDaEQsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBQ2hELE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQUNsRCxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBRTFDLE1BQU0sT0FBTyxVQUVYLFNBQVEsYUFBYTtJQUNMLElBQUksQ0FBMEI7SUFFOUMsWUFDRSxJQUE2QixFQUM3QixVQUF5QixFQUFFO1FBRTNCLE9BQU8sR0FBRztZQUNSLEdBQUcsT0FBTztTQUNYLENBQUM7UUFFRixNQUFNLGdCQUFnQixHQUFHLElBQUksY0FBYyxDQUN6QyxLQUFLLElBQUksRUFBRTtZQUNULE1BQU0sT0FBTyxHQUFHLE1BQU0sSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFDO1lBQ3JDLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQztnQkFDYiwrREFBK0Q7Z0JBQy9ELE1BQU0sSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBQ3RCLENBQUM7WUFDRCxPQUFPLE9BQU8sQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQztRQUMvRCxDQUFDLEVBQ0Q7WUFDRSxlQUFlLEVBQUUsT0FBTztTQUN6QixDQUNGLENBQUM7UUFFRixNQUFNLFlBQVksR0FBRyxJQUFJLGNBQWMsQ0FDckMsS0FBSyxFQUFFLEdBQUcsSUFBVyxFQUFFLEVBQUU7WUFDdkIsTUFBTSxNQUFNLEdBQUcsTUFBTSxJQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUM7WUFDMUMsSUFBSSxNQUFNLEtBQUssS0FBSyxFQUFFLENBQUM7Z0JBQ3JCLE9BQU8sWUFBWSxDQUFDLE9BQU8sQ0FBQztZQUM5QixDQUFDO1FBQ0gsQ0FBQyxFQUNEO1lBQ0UsZUFBZSxFQUFFLE9BQU8sQ0FBQyxlQUFlO1NBQ3pDLENBQ0YsQ0FBQztRQUVGLEtBQUssQ0FDSDtZQUNFLGdCQUFnQjtZQUNoQixJQUFJLENBQUMsWUFBWTtnQkFDZixDQUFDLENBQUMsSUFBSSxhQUFhLENBQUMsWUFBWSxFQUFFLElBQUksQ0FBQyxZQUFZLENBQUM7Z0JBQ3BELENBQUMsQ0FBQyxZQUFZO1NBQ2pCLEVBQ0QsT0FBTyxDQUNSLENBQUM7UUFFRixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztRQUVqQixvQkFBb0I7UUFDcEIsSUFBSSxDQUFDLFdBQVcsQ0FDZCxRQUFRLEVBQ1IsQ0FBQyxNQUFNLEVBQUUsRUFBRTtZQUNULElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ2hDLENBQUMsRUFDRCxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FDWixDQUFDO0lBQ0osQ0FBQztJQUVNLE1BQU0sQ0FBQyxZQUFZO1FBQ3hCLE1BQU0sTUFBTSxHQUFHLElBQUksYUFBYSxDQUFDLENBQUMsSUFBSSxVQUFVLEVBQUUsRUFBRSxJQUFJLFVBQVUsRUFBRSxDQUFDLENBQUMsQ0FBQztRQUN2RSxxQ0FBcUM7UUFDckMsVUFBVSxDQUFDLGNBQWMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUM7UUFDbEMsT0FBTyxNQUFNLENBQUM7SUFDaEIsQ0FBQztDQUNGIn0=